
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const updatePassword = (params) => {
    return axios.post(`${backendHost}/api/admin/change-password`, params);
};

export {
    updatePassword
}